module.exports = __webpack_public_path__ + "img/pauli-z-root-27.99b89924.svg";